import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { PastureController } from 'src/controllers/pasture.controller'
import { PastureDto } from 'src/dto/pasture.dto'

const pastureController = new PastureController()

export function useGetPastureList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<PastureDto[], Error>({
    queryKey: ['getPastureList', farmId],
    queryFn: () => pastureController.getPastureList(farmId!),
    enabled: !!farmId
  })
}
